"use client";

import { HorizontalLine } from "@faire/web/slate/Layout";
import * as React from "react";

import { Spacer } from "../spacing";

import { Pagination } from "./Pagination";
import { FooterWrapper } from "./styles";

export const PaginationFooter: React.FC<Pagination.IProps> = (props) => {
  return (
    <FooterWrapper>
      <HorizontalLine />
      <Spacer size="2x" />
      <Pagination {...props} />
      <Spacer size="2x" />
      <HorizontalLine />
    </FooterWrapper>
  );
};
